import { useTranslation } from 'react-i18next'
import { Base } from '@itsrever/design-system'

// The filter bars' copy for Base.ChecklistPopover; without `search` there is no search box.
export const useChecklistLabels = (search?: string) => {
  const { t } = useTranslation()
  return {
    clearAll: t('filter.clear_all'),
    cancel: t('filter.cancel'),
    apply: t('filter.apply'),
    selectAll: t('filter.select_all'),
    noOptions: t('filter.no_options_title'),
    search
  }
}

export const renderChecklistCount = (count: number) => (
  <Base.Badge variant="count">{count}</Base.Badge>
)
